// ** React Imports
import { Suspense, lazy } from "react";
import ReactDOM from "react-dom";

// ** Redux Imports
import { Provider } from "react-redux";
import { store } from "./redux/storeConfig/store";

// ** Toast & ThemeColors Context
import { ToastContainer } from "react-toastify";
import IdleWarning from "./components/IdleWarning";
import { ThemeContext } from "./utility/context/ThemeColors";

// ** Error Boundary
import ErrorBoundary from "./components/ErrorBoundary";
import VersionBadge from "./components/VersionBadge";

// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner";

// ** Ripple Button
import "./@core/components/ripple-button";

// ** PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-jsx.min";

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";

// ** React Toastify
import "@styles/react/libs/toastify/toastify.scss";

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";

// ** Service Worker
import * as serviceWorker from "./serviceWorker";

// ** i18n
import './configs/i18n'

// ** Lazy load app
const LazyApp = lazy(() => import("./App"));

// ** Global unhandled rejection handler (logs only — API layer handles toasts)
window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault();
  console.error('[Unhandled Rejection]', event.reason);
});

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary>
      <Suspense fallback={<Spinner />}>
        <ThemeContext>
          <LazyApp />
          {/* Warns before App\Http\Middleware\IdleTimeout signs them out. App-wide so it does
              not depend on which screen they are on. See components/IdleWarning. */}
          <IdleWarning />
          <ToastContainer newestOnTop />
        </ThemeContext>
      </Suspense>
      <VersionBadge />
    </ErrorBoundary>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
